module.exports = __webpack_public_path__ + "fonts/Agency_FB.f9b9a4fc.ttf";